import React from "react";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

const AlertWrapper = ({ children }) => {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={4500}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {children}
    </>
  );
};

export default AlertWrapper;
